import React from "react";

import { Container, Logo, Label } from "./styles";

function Header() {
  return (
    <Container>
      <Logo />
      <Label>Treinamento Online</Label>
    </Container>
  );
}

export default Header;
